import FormsyInput from '@components/Textfield/withFormsy'
import { FIELD_CLASS_NAME } from './constants'
import { withTranslate } from '@i18n/utils'
import { useBoletoFormTranslate } from './utils'

const BoletoFormSimpleField = ({ name, defaultValue, translate, className = FIELD_CLASS_NAME }) => {
    const { t, tLabel } = useBoletoFormTranslate(translate)

    return (
        <div className={className}>
            <FormsyInput
                defaultValue={defaultValue}
                name={name}
                required
                placeholder={tLabel(name)}
                validationError={t('validation.required')}
            />
        </div>
    )
}

export default withTranslate(BoletoFormSimpleField)
